import React, {useEffect} from "react";
import {raffleDraws} from "../../store/raffle.store";
import {loadingAnimation, useForceUpdate} from "../../services/misc.functions";
import {getRaffleDraws} from "../../services/raffle.service";
import paths from "../../paths";
import {useNavigate} from "react-router-dom";
import sanalOyunIcon from "../../assets/icons/sanal-oyunlar-icon-black.svg";
import milliPiyangoIcon from "../../assets/icons/milli-piyango-icon.svg";
import scratchIcon from "../../assets/icons/kazi-kazan.svg";

export default function HomeRaffles() {
    const forceUpdate = useForceUpdate();
    const navigate = useNavigate();

    useEffect(() => {
        if (raffleDraws?.length === 0) {
            loadingAnimation(true);
            getRaffleDraws().then(() => {
                loadingAnimation(false);
                forceUpdate();
            });
        }

        return () => {
        };
    }, []);

    return (
        <div className={"col-12"}>
            <div className={"home-raffle-slider"}>
                <div className={"row"}>
                    <div
                        className={"col-3"}
                        onClick={() => {
                            navigate(paths.games.url);
                        }}
                    >
                        <div className="home-raffle-tab-item border">
                            <img src={"../../assets/icons/esans-icon.png"} width={36} height={36}
                                 alt={"e-sans"}/>
                            <h2>
                                ŞANS OYUNLARI
                            </h2>
                        </div>
                    </div>
                    <div
                        className={"col-3"}
                        onClick={() => {
                            navigate(paths.vrgames.url);
                        }}
                    >
                        <div className="home-raffle-tab-item border">
                            <div className="ribbon ribbon-home">
                                <span>YENİ</span>
                            </div>
                            <img width={36} height={36} src={sanalOyunIcon} alt="sanal-oyunlar"/>
                            <h2>
                                SANAL OYUNLAR
                            </h2>
                        </div>
                    </div>
                    <div
                        className={"col-3"}
                        onClick={() => {
                            navigate(paths.numericgames.url);
                        }}
                    >
                        <div className="home-raffle-tab-item border">
                            <div className="ribbon ribbon-home">
                                <span>YENİ</span>
                            </div>
                            <img width={36} height={36} src={milliPiyangoIcon} alt="sanal-oyunlar"/>
                            <h2>
                                SAYISAL OYUNLAR
                            </h2>
                        </div>
                    </div>
                    <div
                        className={"col-3"}
                        onClick={() => {
                            navigate(paths.sisalscratch.url);
                        }}
                    >
                        <div className="home-raffle-tab-item border">
                            <div className="ribbon ribbon-home">
                                <span>YENİ</span>
                            </div>
                            <img width={44} height={44} src={scratchIcon} alt="kazi-kazan" color={"#0000"}/>
                            <h2>
                                KAZI KAZAN
                            </h2>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
